'use client';

import { usePathname } from 'next/navigation';

/**
 * Returns true when the current pathname is one of `ownRoutes`. Use this to self-close
 * a component after a soft navigation leaves it stale.
 *
 * Next can leave a route's UI mounted behind the new one in two situations:
 *  - the root layout's `children` slot stays mounted during a soft nav to a sibling
 *    intercepted route (documented behavior, not a bug):
 *    https://nextjs.org/docs/app/api-reference/file-conventions/intercepting-routes
 *  - an intercepted route's own slot (e.g. `@modal`) isn't unmounted on a soft nav to
 *    another intercepted route (a Next.js bug):
 *    https://github.com/vercel/next.js/discussions/50284
 */
const useIsOwnRoute = (ownRoutes: string[]): boolean => {
  const pathname = usePathname();
  return ownRoutes.includes(pathname);
};

export default useIsOwnRoute;
